const styles = {
  root: {
    '& .MuiTableCell-root': {
      fontSize: '13px',
    },
  },
};

export default styles;
